import {
    DivolteEvent,
    Loader,
} from '@/app/modules/Metrics/loaders/ClickStream';

export interface ClickStreamBootstrap {
    sessionId: string;
    mac: string;
    ObjSegment: string;
    ObjService: string;
    remoteHostInt: string;
    rootObjName: string;
    YMClientID: string;
}

export type ClickStreamUserParams = Omit<ClickStreamBootstrap, 'YMClientID'>;

// Let's Rock!
const service = new Loader();

/**
 * Устанавливаем сервис
 *
 * @param params
 */
export function install(params: ClickStreamBootstrap): Promise<any> {
    const {
        sessionId,
        mac,
        ObjSegment,
        ObjService,
        remoteHostInt,
        rootObjName,
        YMClientID,
    } = params;

    return service.bootstrap({
        merge_parameters: {
            sessionId,
            mac,
            ObjSegment,
            ObjService,
            remoteHostInt,
            rootObjName,
            YMClientID: YMClientID || '0',
        },
    });
}

export function signal(send_parameters: DivolteEvent) {
    if (send_parameters == null) {
        return;
    }

    service.send(send_parameters);
}
